import { defineAction } from '~/prix'
import actionJson from './privateFileCreateUpload.action.json' with { type: 'json' }
import { z } from 'zod'

const privateFileCreateUploadDefinition = defineAction({
  ...actionJson,
  input: z.object({
    kind: z.string().min(1),
    originalFileName: z.string().min(1),
    mimeType: z.string().min(1).nullish(),
  }),
  output: z.object({
    fileId: z.string().uuid(),
    objectPath: z.string(),
    uploadUrl: z.string(),
    requiredHeaders: z.record(z.string()),
  }),
})

export default privateFileCreateUploadDefinition
